import React, { useState, useRef, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import logo from "../assets/images/logo.png";
import "../assets/css/Header.css";
import { FiUser, FiChevronDown, FiLogOut, FiMenu } from "react-icons/fi";

const Header = ({ collapsed, setCollapsed }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const token = localStorage.getItem("token");

  // dropdown state
  const [open, setOpen] = useState(false);

  // ref for click-outside detection
  const dropdownRef = useRef(null);

  // hide user menu on login page
  const isLoginPage = location.pathname === "/login";

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/login", { replace: true });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setOpen(false);
      }
    };

    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open]);

  // Optional: close dropdown on route change
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      className="app-header"
      style={{
        "--sidebar-width": collapsed ? "60px" : "240px",
      }}
    >
      <div className="header-left">
        <img src={logo} alt="Logo" className="header-logo" />
        <span className="header-title">apifdf</span>

        {!isLoginPage && token && (
          <FiMenu
            className="menu-toggle"
            onClick={() => setCollapsed(!collapsed)}
          />
        )}
      </div>

      {!isLoginPage && token && (
        <div className="header-right" ref={dropdownRef}>
          <div
            className="user-box"
            onClick={() => setOpen((prev) => !prev)}
          >
            <FiUser className="user-icon" />
            <span className="user-name">Admin</span>
            <FiChevronDown />
          </div>

          {open && (
            <div className="dropdown">
              <button onClick={handleLogout} className="logout-btn">
                <FiLogOut /> Logout
              </button>
            </div>
          )}
        </div>
      )}
    </header>
  );
};

export default Header;
